import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const ReferencesPerStatusBarChart = ({ data, isLoading }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Number of References",
        data: [],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  });

  useEffect(() => {
    if (isLoading || !data || data.length === 0) {
      return;
    }

    const processData = () => {
      const statusCounts = {};
      data.forEach((item) => {
        const status = item.header.detail.traffic_data.status;
        statusCounts[status] = (statusCounts[status] || 0) + 1;
      });

      const sortedStatuses = Object.entries(statusCounts)
        .sort((a, b) => b[1] - a[1])
        .reduce(
          (acc, curr) => {
            acc.keys.push(curr[0]);
            acc.values.push(curr[1]);
            return acc;
          },
          { keys: [], values: [] }
        );

      setChartData({
        labels: sortedStatuses.keys,
        datasets: [
          {
            label: "Number of References",
            data: sortedStatuses.values,
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
        ],
      });
    };

    processData();
  }, [data, isLoading]);

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      datalabels: {
        color: "#fff",
        display: true,
        formatter: (value) => (value > 0 ? value : ""),
      },
    },
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          References per Status
        </h2>
      </div>
      <div className="flex-grow relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <FontAwesomeIcon
              icon={faSpinner}
              className="animate-spin text-xl"
            />
            <span className="ml-2 text-lg">Loading...</span>
          </div>
        ) : (
          <Bar data={chartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default ReferencesPerStatusBarChart;
